<!--
 * @Author: qnghe
 * @Date: 2026-03-10 13:45:10
 * @LastEditTime: 2026-06-08 11:25:45
 * @Description: 
-->
    <template>
    <div class="task-release--add">
      <div class="content">
        <el-form :model="editForm" :rules="rules" ref="form" label-width='100px' label-position="right">
          <el-row>
            <el-col :span="24">    
              <el-form-item label="工作项分类" prop="workClassify">
                <common-select ref="workClassify" v-model="editForm.workClassify" :url="$api.common.getDict" :ajaxMethod="'get'" :params="{ItemType:'YearPlanWorkItemClassify'}" 
                :filterData="filterData" optLabel="itemDesc" optValue="itemValue" placeholder="工作项分类" :disabled="editForm.source===3 || uncompleted"></common-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">  
                <el-form-item label="工作项目" prop="workItemContent">
                    <el-input v-model="editForm.workItemContent" placeholder="工作项目" :disabled="editForm.source===3 || uncompleted"></el-input>
                </el-form-item>
            </el-col>
             <!-- <el-col :span="24">  
                <el-form-item label="类别" prop="workItemCategory">
                    <el-autocomplete v-model="editForm.workItemCategory" :fetch-suggestions="queryCategory" placeholder="类别" :disabled="editForm.source===3" clearable></el-autocomplete>
                </el-form-item>
            </el-col> -->
            <el-col :span="18">  
                <el-form-item label="指定人" prop="wkNos" v-if="isBatch" class="select-form-item">
                    <el-select 
                      v-model="editForm.wkNos" ref="selecter"
                      multiple :collapse-tags="isCollapse"
                      disabled max-height="200"
                      :placeholder="placeholder" class="multiple-person-select" clearable :popper-append-to-body="appendBody"
                    >
                        <el-option v-for="item in initWkList" :label="item.wkName" :value="item.wkNo" :key="item.wkNo"></el-option>
                    </el-select>
                    <el-button class="select-btn" type="primary" @click="showUserSelect" style="width: 56px; padding: 12px 4px;">选择</el-button>
                </el-form-item>
                <el-form-item v-else label="指定人" prop="resWkNo">
                    <selecter v-model="editForm.resWkNo" @selecterData="getSelecterData" :jobNo="editForm.resWkNo" :name="editForm.resWkName"></selecter>
                </el-form-item>
            </el-col>
            <el-col :span="6">  
                <el-form-item prop="weight" label-width="0">
                    <el-autocomplete v-model="editForm.weight" :fetch-suggestions="querySearchWeight" placeholder="权重" @input="handleInputChange" clearable :disabled="uncompleted">
                    </el-autocomplete>
                </el-form-item>
            </el-col>
            <el-col :span="12">  
                <el-form-item label="开始时间" prop="startDate">
                    <el-date-picker v-model="editForm.startDate" value-format="yyyy-MM-dd" align="right" type="date" placeholder="选择日期" :disabled="uncompleted"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">  
                <el-form-item label="完成时间" prop="finishDate">
                    <el-date-picker v-model="editForm.finishDate" value-format="yyyy-MM-dd" align="right" type="date" placeholder="选择日期" :disabled="uncompleted"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="24">  
                <el-form-item label="总目标" prop="fullTarget">
                    <el-input type="textarea" v-model="editForm.fullTarget" placeholder="总目标" :disabled="editForm.source===3 || uncompleted"></el-input>
                </el-form-item>
            </el-col>
            </el-row>
        </el-form>
      </div>
      <div class="btn-wrap">
        <el-checkbox v-if="!isBatch" v-model="checked" class="releaseAlways">持续发布</el-checkbox>
        <el-button type="save" class="btn" @click="save">保存</el-button>
        <el-button type="saveAndRelease" class="btn" v-if="!uncompleted" @click="saveAndRelease">发布</el-button>
        <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
      </div>
      <common-dialog ref="commonDialog" :title="dialogContent.title" :width="dialogContent.width" :showClose="true" :appendBody="true">
        <template slot="content">
          <component v-bind:is="dialogContent.componentName" :users="userData" :editData="editData" @updateUsers="updateUsers" :isShowAllDelete="!uncompleted"></component>
        </template>
      </common-dialog>
  </div>
</template>
<script>
import XEUtils from 'xe-utils'
export default {
 components: {
    selecter:()=>import('@/component/global/customerSelect'),
    UserSelectDialog:()=>import('@/component/global/UserSelectDialog'),
  },
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    },
    isBatch: Boolean,
    isCollapse: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    const validateStartTime = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择开始时间'));
      }else {
        if (this.editForm.finishDate) {
          if(XEUtils.timestamp(value)>XEUtils.timestamp(this.editForm.finishDate)){
              return callback(new Error('开始时间不能大于最终完成时间'));
          }else {
            callback();
          }
        }
      }
    }
    const validateEndTime = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择完成时间'));
      }else {
        if (this.editForm.startDate) {
          if(XEUtils.timestamp(value)<XEUtils.timestamp(this.editForm.startDate)){
              return callback(new Error('最终完成时间不能早于开始时间'));
          }else{
            callback();
          }
        }
      }
    }
    return {
       rules: {
        workClassify: [
          { required: true, message: '请选择工作属性', trigger: 'change' },
        ],
        // workItemCategory: [
        //   { required: true, message: '请输入类别', trigger: 'change' },
        //   { max: 64, message: '最多64个字符', trigger: 'blur' }
        // ],
        fullTarget: [
          { required: true, message: '请输入总目标', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'change' }
        ],
        startDate: [
          { required: true, validator: validateStartTime, trigger: 'change' },
        ],
        finishDate: [
          { validator: validateEndTime, trigger: 'change' },
        ],
        resWkNo: [
          { required: true, message: '请选择指定人', trigger: 'change' },
        ],
        wkNos: [
          { required: true, type: 'array', message: '请选择指定人', trigger: 'change' },
        ],
        weight: [
          { required: true, message: '请填写权重', trigger: 'change' }
        ],
        workItemContent: [
          { required: true, message: '请输入工作项目', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'change' }
        ]
      },
      id: 'id',
      editForm:{
        wkNos: [],
      },
      weightList:[],
      checked:false,
      seleterData:[],
      isEdit:false,
      categoryList: [],

      userData: [],
      initWkList: [],
      dialogContent: {},
    }
  },
  mounted(){
    if (this.editForm.groupId){
      this.isEdit = true
    }
    this.getWeightDict();
    this.getCategory();
    this.$nextTick(() => {
      this.$refs.form.clearValidate();
    })
  },
  methods:{
    getWeightDict(){
        this.$ajax.get(this.$api.common.getDict,{ItemType:'WorkWeight'}).then((res)=>{
            if(res.code===0){
                this.weightList=[];
                res.data.rows.forEach(t=>{
                  this.weightList.push({value:eval(t.itemValue)});
                });
            }
        });
    },
    querySearchWeight(queryString, cb) {
        let weightList = this.weightList;
        // 调用 callback 返回建议列表的数据
        cb(weightList);
    },
    filterData(res){
      return res && res.data && res.data.rows.filter(t => !t.itemGroup);
    },
    save() {
      this.$refs["form"].validate(valid => {
        //通过后提交数据
        if (valid) {
          let apiStr = this.$api.add.PublishYearWork.adu;
          if (this.isBatch) {
            apiStr = this.$api.add.PublishYearWork.batchAdd;
            this.editForm.detailResWkInfos = this.editForm.resWks;
          } else {
            this.editForm.resWkName = this.editForm.resWkNo ? this.seleterData.find(t => t.jobNo == this.editForm.resWkNo).name : '';
            this.editForm.detailResWkInfos = [{
              resWkName: this.editForm.resWkName,
              resWkNo: this.editForm.resWkNo,
            }]
          }
          this.editForm.source = this.editForm.groupId ? this.editForm.source : 1;
          this.editForm.finishFullTarget = this.editForm.fullTarget;
          const params = {
            ...this.editForm,
            wkNos: undefined,
            resWks: undefined,
          }
          if (params.id) params.oldEntityId = params.id;
          this.$ajax.post(apiStr, params).then(res=>{
            if (res.code === 0){
              this.$refs.form.resetFields();
              this.$message.success('保存成功');
              this.$emit('submitSuccess');
              this.editForm = {wkNos: []};
              if(!this.checked) this.$parent.$parent.hide();
            }
          });
        }
      });
    },
    saveAndRelease(){
      this.$refs["form"].validate(valid=>{
        //通过后提交数据
        if(valid){
          let apiStr = this.$api.add.PublishYearWork.saveAndRelease;
          if (this.isBatch) {
            apiStr = this.$api.add.PublishYearWork.batchSaveAndRelease;
            this.editForm.detailResWkInfos = this.editForm.resWks;
          } else {
            this.editForm.resWkName=this.editForm.resWkNo? this.seleterData.find(t=>t.jobNo==this.editForm.resWkNo).name: '';
            this.editForm.detailResWkInfos = [{
              resWkName: this.editForm.resWkName,
              resWkNo: this.editForm.resWkNo,
            }]
          }
          this.editForm.source=this.editForm.groupId ? this.editForm.source: 1;
          this.editForm.finishFullTarget = this.editForm.fullTarget;
          const params = {
            ...this.editForm,
            wkNos: undefined,
            resWks: undefined,
          }
          if (params.id) params.oldEntityId = params.id;
          this.$ajax.put(apiStr, params).then(res=>{
            if(res.code===0){
                this.$refs.form.resetFields();
                this.$message.success('发布成功');
                this.$emit('submitSuccess');
                this.editForm = {wkNos: []};
                if(!this.checked) this.$parent.$parent.hide();
                if(this.isBatch) this.$router.push('/manage/export-task/index')
            }
          });
        }
      })
    },
    getSelecterData(data){
        this.seleterData=data;
    },
    getCategory() {
        this.$ajax.get(this.$api.Identity.Categord.categoryByNo, {userId: sessionStorage.getItem("LOGIN_NAME")}).then(res => {
          const item = res.data;
          this.categoryList = this.filterCategory(item);
        });
      },
      queryCategory(queryString, cb) {
         let categoryList = this.categoryList;
        // 调用 callback 返回建议列表的数据
        cb(categoryList);
    },
    handleInputChange(value) {
      value = value + '';
      value = value.trim();
      // 只能输入数字
      value = value.replace(/[^\d]/g, '')
      if (value) {
        value = parseInt(value);
        if (value < 1) value = 1;
        if (value > 100) value = 100;
      }
      this.editForm.weight = value;
    },
    showUserSelect() {
      this.userData = JSON.parse(JSON.stringify(this.initWkList));
      this.dialogContent = {
        title: '人员',
        componentName: 'UserSelectDialog',
        width: '720px'
      }
      this.$refs.commonDialog.show()
    },
    updateUsers(list) {
      this.initWkList = list;
      this.editForm.wkNos = this.initWkList.map(item => item.wkNo);
      this.editForm.resWks = this.initWkList.map(item => {
        return {
          resWkName: item.wkName,
          resWkNo: item.wkNo,
        }
      });
      this.$nextTick(() => {
        if (this.editForm.wkNos.length > 0) this.$refs.form.clearValidate();
      })
    }
  },
  watch: {
    editData: {
      handler(newValue) {
        this.editForm = JSON.parse(JSON.stringify(newValue || {}))
        const wkList = this.editForm.resWks || [];
        this.initWkList = wkList.map(item => {
          return {
            wkName: item.resWkName,
            wkNo: item.resWkNo,
            deleteFlag: [0, 30].includes(item.status),
          }
        });
        
        let wkNos = this.initWkList.map(item => item.wkNo);
        this.$set(this.editForm, 'wkNos', wkNos);
      },
      immediate: true
    }
  },
  computed: {
    uncompleted() {
      return this.editData.totalStatus === -1;
    }
  }
}
</script>
<style scoped lang='scss'>
  .task-release--add {
    .el-button.el-button--save {
        color: #ffffff;
        background-color: #22b6a1;
        border-color: #22b6a1;
    }
    .el-button.el-button--saveAndRelease {
        background-color: #0dcc82;
        border-color: #0dcc82;
        color: #ffffff;
    }
    .el-button.el-button--clear {
        background-color: #F5BF2B;
        border-color: #F5BF2B;
        color: #ffffff;
    }
    .el-button {
        width: 110px;
        border-radius: 10px;
    }
    .btn-wrap{
        text-align: right;
        margin-top: 10px;
    }
    .el-date-editor.el-input{
        width: 100%;
    }
    .text-btn{
        color: #687371;
    }
    .el-autocomplete{
        width: 100%;
    }
    .customerSelect{
        width: 100%;
    }
    .releaseAlways{
        margin: auto 10px;
    }
  }
  ::v-deep .select-form-item {
    .el-form-item__content {
      display: flex;
    }
    .select-btn {
      margin-left: 10px;
      height: 40px;
    }
    .el-input__suffix {
      display: none;
    }
    
  }
</style>